import { Component } from '@angular/core';

@Component({
  selector: 'app-blob-loader',
  standalone: true,
  templateUrl: './blob-loader.component.html',
  styleUrls: ['./blob-loader.component.scss'],
})
export class BlobLoaderComponent {}
